import React, { createContext, useContext, useState } from 'react';
import { translations } from './translations';

const LanguageContext = createContext();

// Resolve dot-notation key against an object: 'nav.about' → obj.nav.about
function lookup(obj, key) {
  return key.split('.').reduce((acc, part) => acc && acc[part], obj);
}

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('lang') || 'en';
    document.documentElement.dataset.lang = saved;
    return saved;
  });

  const t = (key) => {
    const val = lookup(translations[lang], key);
    if (val) return val;
    return lookup(translations.en, key) || key;
  };

  const setLanguage = (l) => {
    localStorage.setItem('lang', l);
    document.documentElement.dataset.lang = l;
    setLang(l);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
